// extracted by mini-css-extract-plugin
export var activeDot = "_1q-c";
export var buttonContainer = "_1q-9";
export var channelButton = "_1q-a";
export var clickable = "_1q-d";
export var content = "_1q-0";
export var contentFull = "_1q-2";
export var contentThird = "_1q-1";
export var contentWrapper = "_1q-7";
export var description = "_1q-5";
export var heightShort = "_1q-f";
export var image = "_1q-3";
export var imageContainer = "_1q-4";
export var selectButton = "_1q-e";
export var spinnerContainer = "_1q-b";
export var titleContent = "_1q-8";
export var titleWrapper = "_1q-6";